import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1475171524__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Thermometer", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1475171524__cls-1{fill:none}.i-1475171524__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "96",
      cy: "146",
      r: "8",
      class: "i-1475171524__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M109.86 124.01a4 4 0 0 1-1.86-3.38V32c0-6.62-5.38-12-12-12s-12 5.38-12 12v88.63c0 1.37-.7 2.65-1.86 3.38C74.54 128.81 70 137.03 70 146c0 14.34 11.66 26 26 26s26-11.66 26-26c0-8.97-4.54-17.19-12.14-21.99M96 162c-8.82 0-16-7.18-16-16 0-7.44 5.11-13.69 12-15.47V32c0-2.21 1.79-4 4-4s4 1.79 4 4v98.53c6.89 1.78 12 8.03 12 15.47 0 8.82-7.18 16-16 16",
      class: "i-1475171524__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M100 130.53V32c0-2.21-1.79-4-4-4s-4 1.79-4 4v98.53c-6.89 1.78-12 8.03-12 15.47 0 8.82 7.18 16 16 16s16-7.18 16-16c0-7.44-5.11-13.69-12-15.47M96 154c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8",
      class: "i-1475171524__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M116 118.51V32c0-11.03-8.97-20-20-20s-20 8.97-20 20v86.51c-8.81 6.4-14 16.52-14 27.49 0 18.75 15.25 34 34 34s34-15.25 34-34c0-10.97-5.19-21.09-14-27.49M96 172c-14.34 0-26-11.66-26-26 0-8.97 4.54-17.19 12.14-21.99a4 4 0 0 0 1.86-3.38V32c0-6.62 5.38-12 12-12s12 5.38 12 12v88.63c0 1.37.7 2.65 1.86 3.38 7.6 4.8 12.14 13.02 12.14 21.99 0 14.34-11.66 26-26 26M144 32h-12c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.21 0 4-1.79 4-4s-1.79-4-4-4M144 56h-12c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.21 0 4-1.79 4-4s-1.79-4-4-4M144 80h-12c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.21 0 4-1.79 4-4s-1.79-4-4-4M144 104h-12c-2.21 0-4 1.79-4 4s1.79 4 4 4h12c2.21 0 4-1.79 4-4s-1.79-4-4-4",
      class: "i-1475171524__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "thermometer"}) } }